import { Vertex2 } from '../vertex-2.class';

export const distance2Cfn = (point1: Vertex2, point2: Vertex2): number => {
	const dx = point2.x - point1.x;
	const dy = point2.y - point1.y;

	return Math.sqrt((dx * dx) + (dy * dy));
};
